"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "canazei": {
    "8a3fcc98": [{
      "hkey": "a1218561",
      "slug": "alba-penia",
      "name": "Alba-Penia",
      "primary": true,
      "skipSearch": false
    }],
    "alba": [{
      "hkey": "a1218561",
      "slug": "alba-penia",
      "name": "Alba-Penia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "canazei"
    }],
    "8aacd982": [{
      "hkey": "a9d1f725",
      "slug": "canazei",
      "name": "Canazei",
      "primary": true,
      "skipSearch": false
    }],
    "gries": [{
      "hkey": "a9d1f725",
      "slug": "canazei",
      "name": "Canazei",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0db7fa3f": [{
      "hkey": "a1218561",
      "slug": "alba-penia",
      "name": "Alba-Penia",
      "primary": true,
      "skipSearch": false
    }],
    "penia": [{
      "hkey": "a1218561",
      "slug": "alba-penia",
      "name": "Alba-Penia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "canazei"
    }]
  }
};
exports["default"] = _default;